<template>
    <toolbar-option :message="message">
        <template slot="primary">
            <toggle
                :value="checked"
                :messages="toggleMessages"
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

/* To make other components such as buttons operate as a link in their
 * vue files,you must pass the isLink prop set to true and set
 * isLinkNew to true in the element's data. The isLink prop sets the
 * default while isLinkNew must exist so the user can toggle the
 * behavior in the interface.
 */

export default {
    name: 'is-link',
    mixins: [baseOption],

    data() {
        return {
            checked: false,
            displayName: 'Whole Element Link',
            message: '* this will have negative side effects if the component has links inside of it',
            toggleMessages: {
                checked: 'On',
                unchecked: 'Off',
            },
        };
    },

    methods: {
        onInput(isChecked) {
            this.selectedElements.forEach((elem) => {
                elem.isLinkNew = isChecked;
                if (!isChecked) {
                    elem.clearLink();
                }
            });

            this.checked = isChecked;
            this.onOptionChange(isChecked);
            this.setChangedData(true);
        },

        onSelectedElement() {
            this.checked = this.selectedElements.every(elem => elem.isLinkNew);
        },
    },
};
</script>
